export default function Comparativa() {
  const comparaciones = [
    {
      aspecto: 'Velocidad de Análisis',
      tradicional: 'Días o semanas investigando manualmente',
      nexus: 'Resultados en segundos con IA'
    },
    {
      aspecto: 'Costo de Herramientas',
      tradicional: 'Suscripciones mensuales de $50-$200',
      nexus: 'Suscripción anual de S/ 25'
    },
    {
      aspecto: 'Identificación de Nichos',
      tradicional: 'Basado en adivinanzas y suerte',
      nexus: 'Datos reales y análisis predictivo'
    },
    {
      aspecto: 'Creación de Creativos',
      tradicional: 'Contratar diseñadores ($300-$500)',
      nexus: 'Generación automática con IA'
    },
    {
      aspecto: 'Estrategias de Venta',
      tradicional: 'Buscar en blogs y videos de YouTube',
      nexus: 'Copys y embudos listos para usar'
    },
    {
      aspecto: 'Curva de Aprendizaje',
      tradicional: 'Meses de prueba y error',
      nexus: 'Implementación inmediata'
    },
    {
      aspecto: 'Actualizaciones',
      tradicional: 'Pagas cada vez que sale algo nuevo',
      nexus: 'Actualizaciones durante todo el año incluidas'
    },
    {
      aspecto: 'Soporte y Comunidad',
      tradicional: 'Estás solo o pagas mentorías caras',
      nexus: 'Comunidad privada incluida'
    }
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-32 bg-white relative overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gradient-radial from-[#FF6B00]/5 to-transparent rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">

        {/* Section Header */}
        <div className="text-center mb-8 sm:mb-12 lg:mb-20">
          <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-1.5 sm:py-2 bg-[#FF6B00]/10 border border-[#FF6B00]/30 rounded-full mb-4 sm:mb-5">
            <div className="w-2 h-2 bg-[#FF6B00] rounded-full animate-pulse"></div>
            <span className="text-[#FF6B00] text-xs sm:text-sm font-bold tracking-wide" style={{ fontFamily: 'Poppins, sans-serif' }}>
              LA DIFERENCIA ES BRUTAL
            </span>
          </div>

          <h2 className="text-3xl sm:text-4xl lg:text-6xl font-black text-[#0A0A0A] leading-tight mb-3 sm:mb-4 lg:mb-6 px-2" style={{ fontFamily: 'Poppins, sans-serif' }}>
            <span className="text-[#FF6B00]">Nexus</span> vs. El Resto
          </h2>

          <p className="text-sm sm:text-base lg:text-xl text-[#0A0A0A]/70 max-w-3xl mx-auto leading-relaxed px-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Mientras otros pierden tiempo y dinero en métodos obsoletos,
            tú estarás <strong className="text-[#0A0A0A] font-semibold">facturando con inteligencia artificial</strong>.
          </p>
        </div>

        {/* ── DESKTOP TABLE (md+) ── */}
        <div className="hidden md:block bg-gradient-to-br from-[#FAF9F6] to-white rounded-3xl border-2 border-[#E0E0DE] shadow-[0_16px_64px_rgba(0,0,0,0.08)] overflow-hidden">

          {/* Header */}
          <div className="grid grid-cols-3 gap-4 p-6 bg-white border-b-2 border-[#E0E0DE]">
            <div className="flex items-center">
              <span className="text-base font-bold text-[#0A0A0A]/60" style={{ fontFamily: 'Poppins, sans-serif' }}>Aspecto</span>
            </div>
            <div className="flex justify-center">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#FF6B00]/5 border border-[#FF6B00]/20 rounded-xl">
                <i className="ri-close-circle-line text-[#FF6B00] text-lg"></i>
                <span className="text-base font-black text-[#0A0A0A]" style={{ fontFamily: 'Poppins, sans-serif' }}>Método Tradicional</span>
              </div>
            </div>
            <div className="flex justify-center">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#00D9FF]/10 border border-[#00D9FF]/30 rounded-xl">
                <i className="ri-checkbox-circle-line text-[#00D9FF] text-lg"></i>
                <span className="text-base font-black text-[#0A0A0A]" style={{ fontFamily: 'Poppins, sans-serif' }}>Nexus AI</span>
              </div>
            </div>
          </div>

          {/* Rows */}
          <div className="divide-y divide-[#E0E0DE]">
            {comparaciones.map((item, index) => (
              <div key={index} className="grid grid-cols-3 gap-4 p-5 hover:bg-white/50 transition-colors">
                <div className="flex items-center">
                  <span className="text-sm font-bold text-[#0A0A0A]" style={{ fontFamily: 'Poppins, sans-serif' }}>{item.aspecto}</span>
                </div>
                <div className="flex items-center gap-3 bg-[#FF6B00]/5 rounded-xl p-3 border border-[#FF6B00]/10">
                  <i className="ri-close-line text-[#FF6B00] text-xl flex-shrink-0"></i>
                  <p className="text-sm text-[#0A0A0A]/70" style={{ fontFamily: 'Poppins, sans-serif' }}>{item.tradicional}</p>
                </div>
                <div className="flex items-center gap-3 bg-[#00D9FF]/5 rounded-xl p-3 border border-[#00D9FF]/20">
                  <i className="ri-check-line text-[#00D9FF] text-xl flex-shrink-0"></i>
                  <p className="text-sm font-semibold text-[#0A0A0A]" style={{ fontFamily: 'Poppins, sans-serif' }}>{item.nexus}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ── MOBILE CARDS (< md) ── */}
        <div className="md:hidden space-y-3 sm:space-y-4">
          {/* Column headers */}
          <div className="grid grid-cols-2 gap-2 sm:gap-3 mb-2">
            <div className="flex items-center justify-center gap-1 sm:gap-1.5 px-2 sm:px-3 py-1.5 sm:py-2 bg-[#FF6B00]/10 border border-[#FF6B00]/20 rounded-xl">
              <i className="ri-close-circle-line text-[#FF6B00] text-sm sm:text-base"></i>
              <span className="text-[10px] sm:text-xs font-black text-[#0A0A0A]" style={{ fontFamily: 'Poppins, sans-serif' }}>Método Tradicional</span>
            </div>
            <div className="flex items-center justify-center gap-1 sm:gap-1.5 px-2 sm:px-3 py-1.5 sm:py-2 bg-[#00D9FF]/10 border border-[#00D9FF]/30 rounded-xl">
              <i className="ri-checkbox-circle-line text-[#00D9FF] text-sm sm:text-base"></i>
              <span className="text-[10px] sm:text-xs font-black text-[#0A0A0A]" style={{ fontFamily: 'Poppins, sans-serif' }}>Nexus AI</span>
            </div>
          </div>

          {comparaciones.map((item, index) => (
            <div key={index} className="bg-[#FAF9F6] rounded-xl sm:rounded-2xl border border-[#E0E0DE] overflow-hidden">
              {/* Aspecto label */}
              <div className="px-3 sm:px-4 py-1.5 sm:py-2 bg-[#0A0A0A] text-center">
                <span className="text-[10px] sm:text-xs font-bold text-white uppercase tracking-wide" style={{ fontFamily: 'Poppins, sans-serif' }}>{item.aspecto}</span>
              </div>
              <div className="grid grid-cols-2 divide-x divide-[#E0E0DE]">
                <div className="flex items-start gap-1.5 sm:gap-2 p-2 sm:p-3 bg-[#FF6B00]/5">
                  <i className="ri-close-line text-[#FF6B00] text-sm sm:text-base flex-shrink-0 mt-0.5"></i>
                  <p className="text-[10px] sm:text-xs text-[#0A0A0A]/70 leading-snug" style={{ fontFamily: 'Poppins, sans-serif' }}>{item.tradicional}</p>
                </div>
                <div className="flex items-start gap-1.5 sm:gap-2 p-2 sm:p-3 bg-[#00D9FF]/5">
                  <i className="ri-check-line text-[#00D9FF] text-sm sm:text-base flex-shrink-0 mt-0.5"></i>
                  <p className="text-[10px] sm:text-xs font-semibold text-[#0A0A0A] leading-snug" style={{ fontFamily: 'Poppins, sans-serif' }}>{item.nexus}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Highlight Box */}
        <div className="mt-8 sm:mt-12 lg:mt-16 bg-gradient-to-br from-[#FF6B00] to-[#e05e00] rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-12 shadow-[0_16px_64px_rgba(255,107,0,0.3)] text-center">
          <div className="max-w-4xl mx-auto">
            <h3 className="text-xl sm:text-2xl lg:text-4xl font-black text-white mb-2 sm:mb-3 lg:mb-4 leading-tight" style={{ fontFamily: 'Poppins, sans-serif' }}>
              La Decisión Más Obvia de Tu Vida
            </h3>
            <p className="text-sm sm:text-base lg:text-xl text-white/90 mb-5 sm:mb-6 lg:mb-8 leading-relaxed px-2" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Puedes seguir perdiendo tiempo y dinero con métodos obsoletos...<br className="hidden sm:block" />
              O puedes unirte a los que ya están <strong className="font-black">dominando el mercado digital con IA</strong>.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-3 lg:gap-6 mb-6 sm:mb-8">
              {[
                { icon: 'ri-time-line', label: 'Acceso Inmediato' },
                { icon: 'ri-calendar-check-line', label: 'Suscripción Anual — S/ 25' },
                { icon: 'ri-refresh-line', label: 'Acceso por 12 Meses' },
              ].map((b, i) => (
                <div key={i} className="flex items-center gap-1.5 sm:gap-2 px-3 sm:px-4 lg:px-5 py-2 sm:py-2.5 bg-white/10 backdrop-blur-sm rounded-full border border-white/20 w-full sm:w-auto justify-center">
                  <i className={`${b.icon} text-white text-base sm:text-lg lg:text-xl`}></i>
                  <span className="text-white font-bold text-xs sm:text-sm" style={{ fontFamily: 'Poppins, sans-serif' }}>{b.label}</span>
                </div>
              ))}
            </div>

            <button
              onClick={() => {
                const offerSection = document.getElementById('oferta-section');
                if (offerSection) offerSection.scrollIntoView({ behavior: 'smooth' });
              }}
              className="w-full sm:w-auto px-6 sm:px-8 lg:px-10 py-4 sm:py-4 lg:py-5 bg-white text-[#FF6B00] font-black rounded-full shadow-[0_8px_32px_rgba(0,0,0,0.2)] hover:shadow-[0_12px_40px_rgba(0,0,0,0.3)] hover:scale-105 transition-all cursor-pointer text-sm sm:text-base lg:text-xl leading-snug text-center"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              <span className="sm:hidden">Sí, Quiero Nexus Ahora<br />— S/ 25</span>
              <span className="hidden sm:inline">Sí, Quiero Nexus Ahora — S/ 25</span>
            </button>
          </div>
        </div>

      </div>
    </section>
  );
}